<template>

<com-item name="hindex.share" :size="size" :no-border="true" :is-empty="!active" :loading="loading" title="Play Share">

	<template v-slot:about>

		<p>See the play share for {{ your }} h-index and everyone else.</p>

	</template>

	<template v-slot:stats v-if="active">

        <div class="polar" v-if="isPolar">
            <app-visualisation-segments :data="polarOwn" title="Same H-index" />
            <app-visualisation-segments :data="polarAll" title="H-index > 1" />
        </div>

		<app-visualisation-bars :data="bars" v-if="!isPolar" />
		
	</template>

	<template v-slot:buttons>

		<com-toggle :options="options" :value="toggleValue" v-on:change="onToggleChange" />

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'
import comToggle from './../common/Toggle'

export default {

	props: ['fetching', 'you', 'your', 'size'],

	components: {
		'com-item': comItem,
		'com-toggle': comToggle
	},

	data: function() {

		return {
			polarOwn: {
				areas: [
					{title: '0% - 25%'},
					{title: '26% - 50%'},
					{title: '51% - 75%'},
					{title: '76% - 100%'}
				],
				clickable: false,
				size: 20,
				shades: [
					'rgba(17, 105, 135, 0.2)',
					'rgba(17, 105, 135, 0.4)',
					'rgba(17, 105, 135, 0.6)',
					'rgba(17, 105, 135, 0.8)',
					'rgba(17, 105, 135, 1)'
				],
				segments: [],
				dataset: {
					data: []
				}
			},
			polarAll: {
				areas: [
					{title: '0% - 25%'},
					{title: '26% - 50%'},
					{title: '51% - 75%'},
					{title: '76% - 100%'}
				],
				clickable: false,
				size: 20,
				shades: [
					'rgba(17, 105, 135, 0.2)',
					'rgba(17, 105, 135, 0.4)',
					'rgba(17, 105, 135, 0.6)',
					'rgba(17, 105, 135, 0.8)',
					'rgba(17, 105, 135, 1)'
				],
				segments: [],
				dataset: {
					data: []
				}
			},
			bars: {
				datasets: [
					{ type: 'bar', dataType: 'percent', data: [], backgroundColor: '#4881bb', tooltip: '{{value}} of users with same H-index <small>Share between {{x.tooltip}}</small>' },
					{ type: 'bar', dataType: 'percent', data: [], backgroundColor: '#2FC482', tooltip: '{{value}} of all users <small>Share between {{x.tooltip}}</small>' },
				],
				axis: {
					x: {
						labels: [],
						long: true
					},
					y: {
						min: 10,
						points: 10
					}
				}
			}
		}

	},

	computed: {

		loading: function() {

			return this.fetching === 'all'

		},

		isPolar: function() {

			return this.$store.getters['filter/insights/hindex/share'] === 'polar'

		},

		data: function() {

			return this.$store.getters['page/insights/hindex/share']

		},

		active: function() {

			return this.data.all && !this.loading

		},

		options: function() {

			var options = []

			options.push({value: this.$CONSTANTS.INSIGHTS.GRAPH.POLAR, text: 'Polar chart'})
			options.push({value: this.$CONSTANTS.INSIGHTS.GRAPH.BAR, text: 'Bar chart'})

			return options

		},

		toggleValue: function() {

			return this.$store.getters['filter/insights/hindex/share']

		}

	},

	watch: {

		data: function() {

			this.visualise()

		}

	},

	created: function() {

		var range

		for (var i=1; i <= 20; i++) {

			if (i == 20) {

				range = '{{value}}% user{{value.plural}} ' + (((i - 1) * 5) + 4) + '% and 100% share'

			} else {

				range = '{{value}}% user{{value.plural}} between ' + (((i - 1) * 5)) + '% and ' + (((i - 1) * 5) + 4) + '% share'

			}

			this.polarOwn.segments.push({
				label: range
			})

			this.polarOwn.highlight = Math.floor((this.$store.getters['page/insights/hindex/overview'].plays - 1) / 5)

			this.polarAll.segments.push({
				label: range
			})

			range = ((i - 1) * 5) 

			this.bars.axis.x.labels.push({
				label: range + '% - ' + (((i - 1) * 5) + 4) + '%',
				tooltip: range + '% and ' + (((i - 1) * 5) + 4) + '%'
			})

		}

		this.visualise()

	},

	methods: {

		visualise: function() {

			this.polarAll.dataset.data = this.data.all
			this.polarOwn.dataset.data = this.data.own

			this.bars.datasets[0].data = this.data.own
			this.bars.datasets[1].data = this.data.all

		},

		onToggleChange: function(value) {

			this.$store.commit('filter/insights/hindex/share', value)

		}

	}

}

</script>

<style scoped>

.polar {
    display: grid;
    grid-template-columns: 1fr 1fr;
	grid-gap: 4px;
    height: 100%;
}

.is-mobile .polar {
	grid-template-columns: 1fr;
	grid-template-rows: 320px 320px;
}

.polar >>> .segments {
    border: 1px solid #ddd;
	border-radius: 4px;
	background-color: #fff;
}

.polar >>> .segments-dataset {
    width: 200px;
    height: 200px;
    margin-left: -100px;
    margin-top: -100px;
}

.polar >>> .segments-areas-item-title {
    font-size: 12px;
}

</style>